import * as React from "react";
import { Offcanvas } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import {
  Account, EntryItem, DriveUIActionTypes, DriveMessages, PanelStateType, PanelState, getEntityIcon, CollectionEntity, DriveEntryType, Feature,
  DriveFeature, DirectoryEntity
} from "src/common";
import { Icon, Loading } from "src/components";
import { ItemDetails, RenameItemForm, FileDetails, FolderDetails } from "..";
import { EmptyMessage } from "../..";

type AllProps = {
  current_account: Account;
  action?: string;
  entry?: EntryItem;
  collection_info?: CollectionEntity;
  collection_info_error?: string;
  current_directory: DirectoryEntity;
  current_details: boolean; // Pass true for when the panel is opened from the URL OR the toolbar === current_directory
  panel_state: PanelStateType;
  handleAction: ActionHandlerFunction;
};

function DriveSidePanelComponent(props: AllProps) {
  const { current_account, entry, action, panel_state, collection_info, collection_info_error, current_directory, current_details, handleAction } = props;

  // Description: Close the offcanvas and reset current entry - send undefined for entry to reset parent state
  function handleClose() {
    handleAction({ actionType: DriveUIActionTypes.ToggleSidePanel, params: PanelState.off });
  }

  return (
    <Offcanvas
      className="sidebar drive-details"
      backdrop={false}
      show={panel_state === PanelState.on}
      onHide={handleClose}
      placement="end" >
      <Offcanvas.Header closeButton >
        {
          !!entry &&
          <Offcanvas.Title className="rename-div">
            <span>
              <Icon className={entry.type_class || getEntityIcon(entry.type)} />
              {
                !!collection_info?.permissions.locked && <Icon className="icon-lock2" />
              }
            </span>
            {
              Feature.hidden(DriveFeature.Rename, collection_info?.permissions) ?
                <p>{entry.name}</p> :
                !!collection_info &&
                <RenameItemForm
                  entry={entry}
                  current_account={current_account}
                  current_directory={current_directory}
                  collection_info={collection_info}
                  action={action}
                  handleAction={handleAction} />
            }
          </Offcanvas.Title>
        }
      </Offcanvas.Header>
      <Offcanvas.Body>
        {
          !!entry ?
            !!collection_info ?
              <>
                <ItemDetails
                  current_account={current_account}
                  entry={entry}
                  collection_info={collection_info}
                  current_details={current_details}
                  handleAction={handleAction} />
                {
                  entry.type === DriveEntryType.FILE ?
                    <FileDetails
                      current_account={current_account}
                      entry={entry}
                      action={action}
                      collection_info={collection_info}
                      handleAction={handleAction} /> :
                    <FolderDetails
                      current_account={current_account}
                      entry={entry}
                      action={action}
                      collection_info={collection_info}
                      handleAction={handleAction}
                    />
                }
              </> :
              !!collection_info_error ?
                <EmptyMessage message={DriveMessages.problem_with_fetching_collection_info} /> :
                <Loading className="in-place" /> :
            <EmptyMessage message={DriveMessages.no_entry_selected} />
        }
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default React.memo(DriveSidePanelComponent);
